import { useMemo } from "react"
import { gql } from "../../../gql"
import { useQuery } from "@oysterhr/core"
import { StaffProcessOverviewQuery, StaffProcessOverviewQueryVariables } from "../../../gql/graphql"

export const STAFF_PROCESS_OVERVIEW_QUERY = gql(`
  query StaffProcessOverview($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      exemptionForm {
        responses {
          collection {
            answer
            question
          }
        }
      }
      employment {
        id
        startDate
        countryCode
        state
        isPayrollTeamMember
        personalInfo {
          fullLegalName
          firstName
          email
        }
        company {
          id
          name
          depositInvoiceRequired
        }
        invitation {
          id
          sentAt
        }
        hiring {
          id
          agreements {
            id
            agreementType
            isAutomated
          }
          hiringProcess {
            completedAt
            agreementsFieldsBlocked
            agreementsActionsBlocked
            exemptionFormCompleted
            staffTasks {
              ...TodoTasksTaskDetails
            }
            notes {
              ...StaffNoteDetails
            }
            settings {
              ...TodoTasksTaskDetails
            }
          }
        }
        depositBeforeLiability
      }
    }
  }
`)

export function useStaffProcessOverviewData(
  engagementId: StaffProcessOverviewQueryVariables["engagementId"],
) {
  const { data, loading } = useQuery(STAFF_PROCESS_OVERVIEW_QUERY, {
    variables: { engagementId },
    fetchPolicy: "network-only",
  })

  const staffTasks = useMemo(
    () => data?.engagement?.employment?.hiring?.hiringProcess?.staffTasks ?? [],
    [data],
  )
  const notes = useMemo(
    () => data?.engagement?.employment?.hiring?.hiringProcess?.notes ?? [],
    [data],
  )

  return {
    data,
    loading,
    tasks: staffTasks,
    notes,
    employment: data?.engagement?.employment,
  }
}

export type StaffProcessOverviewEmployment = NonNullable<
  StaffProcessOverviewQuery["engagement"]
>["employment"]
